import { action, observable } from 'mobx';
import { ResponseEntity } from '~client/model/response-entity';
import { deleteResaleListing } from '~web/interactor/resale/delete-resale-listing';
import { TaskStore } from '~web/store/base/task-store';

export class DeleteListingStore extends TaskStore<ResponseEntity> {
  @observable deleteConfirmationShown: boolean;

  constructor() {
    super(deleteResaleListing);
    this.deleteConfirmationShown = false;
  }

  @action
  showDeleteConfirmation(): void {
    this.deleteConfirmationShown = true;
  }

  @action
  hideDeleteConfirmation(): void {
    this.deleteConfirmationShown = false;
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src891534606/src/modules/web/src/js/store/selling/delete-listing-store.ts